import { format, isValid, parse, parseISO } from "date-fns";
import { enUS, es } from "date-fns/locale";

import { AVAILABLE_LANGUAGE } from "@/shared/models";
import type { ISODate } from "@/shared/models/legacy-types";
import { getSettingsStoreLanguage } from "@/shared/stores";

/**
 * @deprecated Use `formatDate` from `shared/lib/date-fns/formats.ts` instead.
 *
 * Date formatting has been standardized to ISO8601 in the backend.
 */
export const formatISO = (date: string, dateFormat = "MM/dd/yy") => {
  return format(parseISO(date), dateFormat);
};

export const parseBackendDate = (dateString: string) => {
  const formattedDate = parse(dateString, "yyyy-MM-dd", new Date());

  if (isValid(formattedDate)) {
    return formattedDate;
  }

  return new Date(dateString);
};

/**
 * @deprecated Use `formatDate` from `shared/lib/date-fns/formats.ts` instead.
 *
 * Date formatting has been standardized to ISO8601 in the backend.
 */
export const formatBackendDate = (
  dateString?: string | null,
  dateFormat = "MM/dd/yyyy",
) => {
  if (!dateString) {
    return "";
  }

  const language = getSettingsStoreLanguage();
  const locale = language === AVAILABLE_LANGUAGE.ES ? es : enUS;

  return format(parseBackendDate(dateString), dateFormat, { locale });
};

export const formatBackendDateToVerbose = (dateString?: string) => {
  if (!dateString) {
    return "";
  }

  return format(parseBackendDate(dateString), "MMM dd, yyyy");
};

export const formatToBackendDate = (date: Date) =>
  format(date, "yyyy-MM-dd") as ISODate;

interface DOB {
  year: number;
  month: number;
  day: number;
}

export const isValidDOB = ({ year, month, day }: DOB) => {
  const date = new Date(year, month - 1, day);
  return (
    date.getFullYear() === year &&
    date.getMonth() === month - 1 &&
    date.getDate() === day
  );
};

export const formatDOB = ({ year, month, day }: DOB) => {
  const date = new Date(year, month - 1, day);

  return formatToBackendDate(date);
};
